module.exports = __webpack_public_path__ + "static/media/right-menu-contact-us-icon.7c6eea87.svg";